// passing the path into variables

const banner1 = '/assets/santajuana/Home/new-banner.webp';
// const banner2 = '/assets/santajuana/offices/BusesSaoPaulo-Website-Home-Slide-MainBanner-Desktop2.jpg';
// const banner3 = '/assets/santajuana/Home/BusesSaoPaulo-Website-Home-Slide-MainBanner-Desktop3.jpg';

const destination1 = '/assets/santajuana/nuestros-destinos-santa-juana.webp';
const destination2 =
	'/assets/santajuana/nuestros-destinos-concepcion.webp';

const banner = [banner1];

const destination = [destination1, destination2];

const santajuanaSlides = {
	banner,
	destination,
};

export default santajuanaSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/santajuanaSlides.js